{ "id": "arakne", "name": "Arakne", "sprite": "arakne", "hp": 28, "speed": 195, "radius": 18, "contactDamage": { "element": "air", "min": 4, "max": 7 }, "attackCooldown": 0.6, "xp": 8, "kamas": [1, 4], "resistances": { "air": 10 } }
